<div class="dropdown-row">
  <div class="dropdown-container">
    @if (pageName === "Items") {
      <select
        class="bold border med-gray-border med-gray-text dropdown"
        [(ngModel)]="filters.departmentName"
        (change)="updateFilteredItems()">
        <option value="" selected>All Departments</option>
        @for (d of departments; track d) {
          <option [value]="d">{{ d }}</option>
        }
      </select>
    }
    @if (pageName === "Modifiers") {
      <select
        class="bold border med-gray-border med-gray-text dropdown"
        [(ngModel)]="filters.productType"
        (change)="updateFilteredItems()">
        <option value="" selected>All Locations</option>
        @for (l of locations; track l) {
          <option [value]="l">{{ l }}</option>
        }
      </select>
    }
  </div>
  <div class="dropdown-container">
    <select
      class="bold border med-gray-border med-gray-text dropdown"
      [(ngModel)]="filters.availability"
      (change)="updateFilteredItems()">
      @for (option of availabilityOptions; track option) {
        <option [value]="option.value">{{ option.description }}</option>
      }
    </select>
  </div>
</div>

<div class="border-radius-tiny super-light-gray-bg border light-gray-border filter-container">
  <div class="text-image">
    <img src="/assets/images/Search-Dark.svg" class="pointer" />
  </div>
  <div class="manage-items-filter-content search-container">
    <input
      type="search"
      style="-webkit-appearance: searchfield"
      class="dark-gray-text transparent-bg filter-text"
      placeholder="Search..."
      [(ngModel)]="filters.textSearch"
      (ngModelChange)="updateFilteredItems()"
      ng-class="!!filters.textSearch ? '' : 'empty'" />
  </div>
</div>
